/**
 * <ArtFrame>
 *
 * Vignette muséale d'une œuvre : cadre fin, ombre douce, cartel sous l'image
 * (titre, technique, artiste). Style proche d'une notice de musée.
 *
 * Props :
 *   - art : objet de la collection (id, file, title, technique, note)
 *   - artistName : nom à afficher sur le cartel
 *   - size : "sm" | "md" | "lg"
 *   - showNote : booléen — affiche la note curatoriale sous le cartel
 *   - className : classes supplémentaires sur le wrapper
 */
export default function ArtFrame({
  art,
  artistName = "Joakim Sorola",
  size = "md",
  showNote = false,
  className = "",
}) {
  const aspect = size === "sm" ? "aspect-[4/5]" : "aspect-[1/1]";
  return (
    <figure
      data-testid={`art-frame-${art.id}`}
      className={`group relative ${className}`}
    >
      {/* Cadre / passe-partout */}
      <div className="relative p-2.5 bg-[#F3EFE7] rounded-[2px] shadow-[0_18px_40px_-18px_rgba(11,58,42,0.45)] transition-transform duration-700 group-hover:-translate-y-0.5">
        <div className={`relative ${aspect} overflow-hidden bg-[#0B3A2A]`}>
          <img
            src={art.file}
            alt={art.title}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
          />
          {/* Halo doux au survol */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle at center, rgba(196,164,104,0.0) 30%, rgba(11,58,42,0.20) 100%)",
            }}
          />
        </div>
      </div>

      {/* Cartel muséal */}
      <figcaption className="mt-3 text-center px-1">
        <p className="text-[11px] uppercase tracking-[0.22em] text-[#C9A961]">
          {artistName}
        </p>
        <p className="text-[14px] text-[#0B3A2A] mt-1 font-serif italic">
          {art.title}
        </p>
        <p className="text-[11px] text-slate-500 mt-0.5">{art.technique}</p>
        {showNote && art.note && (
          <p className="text-[12px] text-slate-600 mt-2 leading-relaxed max-w-[280px] mx-auto">
            « {art.note} »
          </p>
        )}
      </figcaption>
    </figure>
  );
}
